export const ROOT_URL = '/';
export const RESERVATIONS_ANALYTICS_URL = '/reservations-analytics';
export const GUESTS_ANALYTICS_URL = '/guests-analytics';
export const LOGIN_URL = '/login';
export const RESET_PASSWORD = '/reset-password';
export const REGISTRATION_URL = '/register';
export const ACTIVATE_ACCOUNT_URL = '/activate-account';
export const ACCEPT_INVITATION_URL = '/accept-invitation';
export const ACTIVATE_PLACE_URL = '/activate-place';
export const ENABLE_RESERVATIONS_URL = '/enable-reservations';
export const ENABLE_GUEST_WEB_URL = '/enable-guest-web';
export const DELETE_ACCOUNT = '/delete-account';
export const NEW_PLACE_SETUP_URL = '/new-place-setup';
export const PLACES = '/places';
export const MANAGEMENT_URL = '/management';
export const SETTINGS_URL = '/settings';
export const FOR_GUESTS_URL = import.meta.env.VITE_GUEST_WEB_URL;
export const ABOUT_URL = '/about';
export const TERMS_AND_CONDITIONS_URL = '/terms-and-conditions';
export const PRIVACY_URL = '/privacy';
export const SITE_MAP_URL = '/site-map';
export const MENU_CATEGORIES_URL = '/menu-categories';
export const CONTACT_URL = '/contact';
export const ACCOUNTING_URL = '/accounting';
export const GUESTBOOK_URL = '/guestbook';
export const CHANGE_INITIAL_PASSWORD_URL = '/change-initial-password';
export const CONFIRM_RESERVATION_URL = '/confirm-reservation';
export const DEACTIVATED_ACCOUNT = '/deactivated-account';

export const publicRoutes = [
  LOGIN_URL,
  RESET_PASSWORD,
  REGISTRATION_URL,
  ACTIVATE_ACCOUNT_URL,
  ACCEPT_INVITATION_URL,
  ACTIVATE_PLACE_URL,
  ABOUT_URL,
  TERMS_AND_CONDITIONS_URL,
  PRIVACY_URL,
  SITE_MAP_URL,
  ENABLE_RESERVATIONS_URL,
  ENABLE_GUEST_WEB_URL,
  DELETE_ACCOUNT,
  CONFIRM_RESERVATION_URL,
  DEACTIVATED_ACCOUNT,
];

export const protectedRoutes = [PLACES, NEW_PLACE_SETUP_URL, MANAGEMENT_URL, SETTINGS_URL, CHANGE_INITIAL_PASSWORD_URL];
